import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Loader from 'components/Loader';

import useGetAddresses from '../hooks/useGetAddresses';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  root: {
    maxWidth: 580,
    height: 360,
    margin: '50px auto',
    [breakpoints.down('xs')]: {
      margin: 'auto',
      position: 'absolute',
      height: '100%',
      width: '100%',
    },
  },
  wrapper: {
    padding: '86px 0',
    textAlign: 'center',
    '& h1': {
      fontSize: 35,
      fontWeight: 400,
      color: palette.cncUI.black,
    },
  },
}));

const SearchAccount = props => {
  const classes = useStyles();
  const { state, changeState, setStep } = props;
  const { form, email, idType } = state;

  const query = useGetAddresses();

  let ssn =
    form && form.ssn && form.ssn.length === 9
      ? form.ssn.substring(0, 3) +
        '-' +
        form.ssn.substring(3, 5) +
        '-' +
        form.ssn.substring(form.ssn.length - 4, form.ssn.length)
      : form.ssn || null;
  let sin =
    form && form.sin && form.sin.length === 9
      ? form.sin.substring(0, 3) +
        '-' +
        form.sin.substring(3, 6) +
        '-' +
        form.sin.substring(form.sin.length - 3, form.sin.length)
      : form.sin || null;

  useEffect(() => {
    const countryFlag = idType === 'sin' ? 'CAN' : null;
    const isMinor = state.isMinor || false;
    const minorName = [form.firstName, form.lastName].join(' ');
    query(ssn, sin, email, countryFlag, idType, isMinor, minorName)
      .then(addresses => {
        changeState({ addresses });
        setTimeout(() => setStep('VerifyAddress'), 1000);
      })
      .catch(err => {
        if (err.message === 'GraphQL error: service') {
          setTimeout(() => setStep('Error'), 1000);
        } else {
          const [type, timestamp, email] = err.message.split(':');
          changeState({ data: { type, timestamp, email } });
          setTimeout(
            () => (email ? setStep('InOurSystem') : setStep('Error')),
            1000,
          );
        }
      });
  }, []);

  return (
    <Paper className={classes.root}>
      <div className={classes.wrapper}>
        <h1>Searching for Your Account</h1>
        <Loader size={70} />
      </div>
    </Paper>
  );
};

export default SearchAccount;
